import { connect } from 'react-redux';
import ResetPassword from './ResetPassword';
import {
  resetAllAuthErrorMessages,
  userResetPassword,
  userSetNewPassword,
  userResetPasswordStatus,
} from '../../actions/Auth';

const mapStateToProps = ({ auth }) => ({
  loader: auth.loader,
  resetPasswordStatus: auth.resetPasswordStatus,
  validationErrors: auth.validationErrors,
});

export default connect(
  mapStateToProps,
  {
    resetAllAuthErrorMessages,
    userResetPassword,
    userResetPasswordStatus,
    userSetNewPassword,
  },
)(ResetPassword);
